import api from "../utils/api";
import { isGuid } from "../utils/string";
import { LOGOUT } from "./types";
import { pack } from "./alert";

/**
 * SEARCH (if your router exposes /p/.. like other modules)
 * GET /payroll/periods/p/:page/s/:size/o/:order/:direction/:search?
 */
export const search = ({
  search = "",
  page = 0,
  size = 25,
  order = "startsOn",
  direction = "DESC",
} = {}) => async (dispatch) => {
  try {
    const term = (search == null || String(search).trim() === "") ? "*" : String(search).trim();
    const enc = encodeURIComponent(term);
    const url = `/payroll/timecards/p/${Number(page)}/s/${Number(size)}/o/${order}/${direction}/${enc}`;
    const res = await api.get(url);
    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
};

/**
 * SAVE (createOrUpdate)
 * POST /payroll/periods
 */
export const save = (payload = {}) => async (dispatch) => {
  try {
    const res = await api.post(`/payroll/timecards`, payload);
    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
};

/**
 * DESTROY
 * DELETE /payroll/periods/i/:uuid
 */
export const destroy = (uuid = null) => async (dispatch) => {
  try {
    if (!isGuid(uuid)) return;
    const res = await api.delete(`/payroll/timecards/i/${uuid}`);
    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
};

export const clockIn = ({staffUuid, atTime, payPeriodUuid}) => async (dispatch) => {
  try {
    const res = await api.post(`/payroll/timecards`, { staffUuid, startsOn: atTime, payPeriodUuid });
    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
}

export const clockOut = ({staffUuid, atTime, uuid}) => async (dispatch) => {
  try {
    const res = await api.post(`/payroll/timecards`, { staffUuid, endsOn: atTime, uuid });
    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
}

export const lock = ({ uuids, byUuid }) => async (dispatch) => {
  try {
    const res = await api.post(`/payroll/timecards/b`, {
      uuids, patches: [
        {
          name: "lockedAt",
          value: new Date()
        },
        {
          name: "lockedByUuid",
          value: byUuid
        },
        {
          name: "status",
          value: "locked"
        }
      ]
    });

    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
}

export const unlock = ({ uuids }) => async (dispatch) => {
  try {
    const res = await api.post(`/payroll/timecards/b`, {
      uuids, patches: [
        {
          name: "lockedAt",
          value: null
        },
        {
          name: "lockedByUuid",
          value: null
        },
        {
          name: "status",
          value: "submitted"
        }
      ]
    });
    
    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
}

export const approve = ({ uuids, byUuid }) => async (dispatch) => {
  try {
    const res = await api.post(`/payroll/timecards/b`, {
      uuids, patches: [
        {
          name: "approvedAt",
          value: new Date()
        },
        {
          name: "approvedByUuid",
          value: byUuid
        },
        {
          name: "status",
          value: "approved"
        }
      ]
    });

    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
}

export const unapprove = ({ uuids }) => async (dispatch) => {
  try {
    const res = await api.post(`/payroll/timecards/b`, {
      uuids, patches: [
        {
          name: "approvedAt",
          value: null
        },
        {
          name: "approvedByUuid",
          value: null
        },
        {
          name: "status",
          value: "locked"
        }
      ]
    });
    
    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
}

export const get = ({ staffUuid, payPeriodUuid, dateOf, uuid }) => async (dispatch) => {
  try {
    let res;
    if (isGuid(uuid)) {
      res = await api.get(`/payroll/timecards/i/${uuid}`);
    } else if (isGuid(payPeriodUuid)) {
      res = await api.get(`/payroll/timecards/s/${staffUuid}/p/${payPeriodUuid}`);
    } else {
      const day = dateOf.getDate();        // 1-31
      const month = dateOf.getMonth() + 1; // 1-12  (getMonth() is 0-11)
      const year = dateOf.getFullYear();   // e.g. 2026
      res = await api.get(`/payroll/timecards/s/${staffUuid}/d/${day}/${month}/${year}`);
    }
    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  } 
}


export const periods = ({ dateOf, uuid }) => async (dispatch) => {
  try {
    let res;
    if (isGuid(uuid)) {
      res = await api.get(`/payroll/periods/i/${uuid}`);
    } else {
      const day = dateOf.getDate();        // 1-31
      const month = dateOf.getMonth() + 1; // 1-12  (getMonth() is 0-11)
      const year = dateOf.getFullYear();   // e.g. 2026
      res = await api.get(`/payroll/periods/d/${day}/${month}/${year}`);
    }
    if (res.data.success != true || !(res.data?.items?.length > 0))
      dispatch(pack(["no pay period available"], "error"));
    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
  
}

export const startBreak = ({ uuid, atTime }) => async (dispatch) => {
  try {
    const res = await api.post(`/payroll/timecards/i/${uuid}/break/start`, { atTime });
    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
}

export const endBreak = ({ uuid, atTime }) => async (dispatch) => {
  try {
    const res = await api.post(`/payroll/timecards/i/${uuid}/break/end`, { atTime });
    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
}
